export const paymentSection = {
  label: "Auszahlungen",
  description: "",
  children: [
    {
      control: "switch",
      name: "vorsteuerabzugsberechtigt",
      label: "Vorsteuerabzugsberechtigt",
      cols: 12,
    },
    {
      control: "select",
      name: "auszahlung_schaden_bank_account_id",
      label: "Auszahlungskonto",
      cols: "12",
      get_api: (formdata) => {
        return {
          target: "options",
          method: "get",
          endpoint: "data/bank-accounts",
          params: {
            objekt_id: formdata?.objekt_id || "",
          },
          setResult: (res) => {
            if (res.data && res.data.length > 0) {
              return [
                {
                  key: "",
                  label: "Individuelle Bankverbindung",
                },
                ...res.data.map((account) => ({
                  key: account.id,
                  label:
                    account.iban +
                    " - " +
                    account.bic +
                    " - " +
                    account.bank_name,
                })),
              ];
            }
          },
        };
      },
    },
    {
      control: "input",
      name: "auszahlung_schaden_kontoinhaber",
      label: "Kontoinhaber",
      cols: "12",
      // valid: "isNotEmpty(item)",
      disabled: "getValue('auszahlung_schaden_bank_account_id')", // Disable if no account is selected
      hidden: "getValue('auszahlung_schaden_bank_account_id')",
    },
    {
      control: "input",
      name: "auszahlung_schaden_bank",
      label: "Bank (Name)",
      cols: "12",
      // valid: "isNotEmpty(item)",
      disabled: "getValue('auszahlung_schaden_bank_account_id')",
      hidden: "getValue('auszahlung_schaden_bank_account_id')",
    },
    {
      control: "input",
      name: "auszahlung_schaden_iban",
      label: "IBAN",
      cols: "6",
      valid: "isIBANOrEmpty(item)",
      disabled: "getValue('auszahlung_schaden_bank_account_id')",
      hidden: "getValue('auszahlung_schaden_bank_account_id')",
    },
    {
      control: "input",
      name: "auszahlung_schaden_bic",
      label: "BIC",
      cols: "6",
      disabled: "getValue('auszahlung_schaden_bank_account_id')",
      hidden: "getValue('auszahlung_schaden_bank_account_id')",
    },
  ],
};
